import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService {
  private originalConsoleError: Function;

  constructor(private snackBar: MatSnackBar) {
    this.originalConsoleError = console.error;
    console.error = this.interceptErrorLogs.bind(this);
  }

  private interceptErrorLogs(...args: any[]) {
    // Display the error as a toast notification
    const message = args[1].message || args[0]
    this.showErrorNotification(message);

    // Log the error to the console
    this.originalConsoleError.apply(console, args);
  }

  private showErrorNotification(errorMessage: string) {
    this.snackBar.open(errorMessage, 'Close', {
      duration: 5000,
      panelClass: ['error-snackbar']
    });
  }
}